import ListSalesDebitNotes from "../../../../components/@documents/sales_debit_notes/ListSalesDebitNotes";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesDebitNotesPage() {

    return (
        <ListSalesDebitNotes 
            routeType={routeTypes.admin}
        />
    )
}